import { render } from "./KeseluruhanKutipanSebenar.vue?vue&type=template&id=336c5c8b"
import script from "./KeseluruhanKutipanSebenar.vue?vue&type=script&lang=js"
export * from "./KeseluruhanKutipanSebenar.vue?vue&type=script&lang=js"

import "./KeseluruhanKutipanSebenar.vue?vue&type=style&index=0&id=336c5c8b&lang=css"
import "./KeseluruhanKutipanSebenar.vue?vue&type=style&index=1&id=336c5c8b&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__